export default function getGoogleMapsURL(latitude: number, longitude: number) {
  const g = `${latitude},${longitude}`;
  return `https://www.google.com/maps/place/${g}`;
}

export function getGoogleMapsURLOfPlace(query: string): string {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    query
  )}`;
}
